import React from 'react';
import { Container } from '../components/ui/Container';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { BookOpen, FileText, Download, Rocket } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ResourcesPage() {
  const guides = [{
    title: 'Getting Started with Flowsense',
    description: 'Your complete guide to setting up Flowsense and running your first flow analysis in under 5 minutes.',
    icon: Rocket,
    category: 'Guide',
    readTime: '5 min read',
    slug: '/guides/getting-started'
  }, {
    title: 'Understanding Flow Health Scores',
    description: 'Learn how Flowsense calculates health scores and what each metric means for your email marketing performance.',
    icon: BookOpen,
    category: 'Guide',
    readTime: '8 min read',
    slug: '/guides/understanding-flow-health-scores'
  }, {
    title: 'Implementing AI Recommendations',
    description: 'Best practices for prioritizing and implementing recommendations to maximize ROI and improve flow performance.',
    icon: FileText,
    category: 'Guide',
    readTime: '10 min read',
    slug: '/guides/implementing-ai-recommendations'
  }, {
    title: 'Agency White-Label Setup',
    description: 'Complete guide to setting up custom domains and branded reports for your agency clients with white-label features.',
    icon: BookOpen,
    category: 'Guide',
    readTime: '12 min read',
    slug: '/guides/agency-white-label-setup'
  }, {
    title: 'Flow Optimization Playbook',
    description: 'Proven strategies for optimizing Welcome, Abandonment, and Post-Purchase flows with real-world examples.',
    icon: Download,
    category: 'Template',
    readTime: 'PDF Download',
    slug: '#'
  }, {
    title: 'ROI Reporting Template',
    description: 'Ready-to-use spreadsheet template for tracking and reporting flow optimization ROI to stakeholders.',
    icon: Download,
    category: 'Template',
    readTime: 'Excel Download',
    slug: '#'
  }];
  return <div className="bg-white" data-id="element-1992">
      {/* Hero */}
      <div className="bg-gray-900 py-20 lg:py-32 text-center text-white" data-id="element-1993">
        <Container data-id="element-1994">
          <h1 className="text-4xl font-bold tracking-tight text-white sm:text-5xl mb-6" data-id="element-1995">
            Resources & Guides
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto" data-id="element-1996">
            Everything you need to master flow optimization and maximize your
            Klaviyo ROI.
          </p>
        </Container>
      </div>

      {/* Guides Grid */}
      <section className="py-24" data-id="element-1997">
        <Container data-id="element-1998">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1999">
            {guides.map((guide, index) => <Card key={index} className="hover:shadow-lg transition-shadow flex flex-col" data-id="element-2000">
                <CardContent className="p-6 flex flex-col flex-grow" data-id="element-2001">
                  <div className="flex items-center justify-between mb-4" data-id="element-2002">
                    <div className="p-2 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 rounded-lg" data-id="element-2003">
                      <guide.icon className="h-6 w-6 text-white" data-id="element-2004" />
                    </div>
                    <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-2005">
                      {guide.category}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-2006">
                    {guide.title}
                  </h3>
                  <p className="text-gray-600 mb-4 flex-grow" data-id="element-2007">
                    {guide.description}
                  </p>
                  <div className="flex items-center justify-between mt-auto" data-id="element-2008">
                    <span className="text-sm text-gray-500" data-id="element-2009">
                      {guide.readTime}
                    </span>
                    {guide.slug !== '#' ? <Link to={guide.slug} data-id="element-2010">
                        <Button variant="link" className="p-0 h-auto" data-id="element-2011">
                          Read More →
                        </Button>
                      </Link> : <Button variant="link" className="p-0 h-auto opacity-50 cursor-not-allowed" data-id="element-2012">
                        Coming Soon
                      </Button>}
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </Container>
      </section>

      {/* CTA */}
      <section className="py-24 bg-gray-900" data-id="element-2013">
        <Container data-id="element-2014">
          <div className="text-center max-w-3xl mx-auto" data-id="element-2015">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl mb-6" data-id="element-2016">
              Ready to Start Optimizing?
            </h2>
            <p className="text-xl text-gray-300 mb-10" data-id="element-2017">
              Put these guides into action with Flowsense.
            </p>
            <a href="https://go.useflowsense.com/signup" data-id="element-2018">
              <Button size="lg" data-id="element-2019">Sign Up</Button>
            </a>
          </div>
        </Container>
      </section>
    </div>;
}